import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './Icons';
export function Testimonials() {
  const testimonials = [{
    name: 'María G.',
    location: 'Houston, TX',
    text: 'Llevaba años leyendo libros de prosperidad sin resultados. En la segunda semana del protocolo sentí un cambio real: dejé de sentir ansiedad al revisar mi cuenta bancaria. Hoy cobro lo que vale mi trabajo sin culpa.',
    highlight: 'Dejé de sentir ansiedad financiera en 2 semanas'
  }, {
    name: 'Carlos R.',
    location: 'Miami, FL',
    text: 'Siempre ganaba bien pero el dinero desaparecía. El Protocolo RNS me hizo entender que era mi sistema nervioso saboteándome. Después de los 21 días, por primera vez en años logré ahorrar consistentemente.',
    highlight: 'Por primera vez en años logré ahorrar'
  }];
  return <section className="bg-secondary py-10 md:py-16 px-4 md:px-12 border-y border-card" data-id="element-289">
      <div className="max-w-4xl mx-auto" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-10" data-id="element-291">
          <h2 className="font-playfair font-bold text-3xl md:text-4xl text-warm-white mb-2" data-id="element-292">
            Lo que dicen quienes ya lo aplicaron
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-id="element-293">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-card border border-card rounded-xl p-6 md:p-8 text-center flex flex-col" data-id="element-294">
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-295">
                <CheckIcon className="w-4 h-4 text-gold" data-id="element-296" />
                <span className="font-inter font-bold text-gold text-sm" data-id="element-297">
                  {t.highlight}
                </span>
              </div>

              <p className="font-inter text-warm-muted text-sm md:text-base leading-relaxed mb-6 flex-1 italic" data-id="element-298">
                "{t.text}"
              </p>

              <div data-id="element-299">
                <div className="font-inter font-semibold text-warm-white text-sm" data-id="element-300">
                  {t.name}
                </div>
                <div className="font-inter text-warm-disabled text-xs" data-id="element-301">
                  {t.location}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}